const host = window.location.hostname;
const isDev = host === 'meet-dev.gaayak.in';
const APPCONFIG = {
  endPoint: isDev ? 'https://devapi.gaayak.in' : 'https://api.gaayak.in',
  // endPoint: 'https://5051-106-51-0-211.ngrok-free.app',
};
export default APPCONFIG;
